import styled from 'styled-components';

export const StyledAgentCreated = styled.div`
  width: 100%;
  color: var(--ink);

  .holder {
    max-width: 400px;
    margin: 0 auto;
    padding: 10px 0 24px;
    text-align: center;
    color: var(--quiet);

    @media (min-width: 768px) {
      font-size: 16px;
      line-height: 24px;
    }

    p {
      margin: 0;
      color: var(--quiet);
    }
  }

  .img-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
  }

  .icon {
    display: block;
    font-size: 48px;
    line-height: 1;
    color: var(--o2);
    margin: 0 auto;
  }

  button {
    display: block;
    margin: 0 auto;
  }
`;
